import React from "react"
import styled, { keyframes } from "styled-components"
import C from "../../../components/Color"

const show = keyframes`
  0% {
    top: 0;
  }
  
  100% {
    top: 100%;
  }
`

const focus = keyframes`
  0% {
  }

  70% {
    transform: scale(1.3);
  }
  
  100% {
    transform: scale(1);
  }
`

const Hide = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10000;
  background: white;
  height: 100%;
  animation: ${show} 0.3s ease-out;
  animation-fill-mode: both;
`

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`

const TextIcon = styled.div`
  font-family: Recife Text, serif;
  font-weight: 700;
  font-size: 22px;
  animation: ${focus} 0.3s ease-out;
  animation-delay: 0.2s;
  animation-fill-mode: both;
`

export default () => (
  <Wrapper>
    <Hide />
    <TextIcon>
      <C type="secondary">!</C>
    </TextIcon>
  </Wrapper>
)
